/* eslint-disable */
import './emailSubscribe.css'
import SubscribeEmailFormIndexView from './subscribeForm';

export default SubscribeEmailFormIndexView;